// @owners { team: patients-team }
import {
  type VacationSuppliesEndpointLatestRequest,
  type VacationSuppliesEndpointLatestResponse,
} from '@alto/scriptdash/alto/patient_app/vacation_supplies/v1/vacation_supplies_endpoint';
import { get } from '~shared/helpers/apiHelper';
import { useQuery } from '~shared/react-query';

/**
 * @deprecated prefer using auto-generated endpoints directly with `apiEndpointHandler`
 * @see https://github.com/scriptdash/clients/pull/7913
 */
export const fetchLatestVacationSupply = async ({
  prescription_id,
  status,
}: VacationSuppliesEndpointLatestRequest): Promise<VacationSuppliesEndpointLatestResponse> => {
  return get(
    `/vacation_supplies/latest`,
    {
      prescription_id,
      status,
    },
    {
      version: 'v1',
    },
  ).then((response) => {
    if (response.errors?.length) {
      throw new Error(response.errors);
    }
    return response;
  });
};

/**
 * @deprecated prefer using auto-generated endpoints directly with `apiEndpointHandler`
 * @see https://github.com/scriptdash/clients/pull/7913
 */
export const useFetchLatestVacationSupply = ({ prescription_id, status }: VacationSuppliesEndpointLatestRequest) => {
  return useQuery<VacationSuppliesEndpointLatestResponse>({
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @alto/prefer-query-key-factory
    queryKey: ['vacation-supply-details', { prescriptionId: prescription_id, status }],
    queryFn: () => fetchLatestVacationSupply({ prescription_id, status }),
  });
};
